import React from 'react'
import styled from 'styled-components'

function TableHeader({ title, align = 'left', ...props }) {
  return (
    <Header {...props} align={align}>
      {title}
    </Header>
  )
}

const Header = styled.th`
  padding-left: ${props => (props.align === 'left' ? 15 : 10)}px;
  padding-right: ${props => (props.align === 'left' ? 0 : 10)}px;
  padding-top: 40px;
  padding-bottom: 20px;
  text-align: ${props => props.align};
  white-space: nowrap;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.75px;
  color: #9B9B9B;

  @media only screen and (max-width: 700px) {
    padding-left: ${props => (props.align === 'left' ? 10 : 5)}px;
    padding-right: ${props => (props.align === 'left' ? 0 : 5)}px;
  }
`

export default TableHeader
